var JL = JL || {};

JL.add_to_cart = function( variant_id, qty = 1, refresh = true ){

    var updates = {};
    updates[ parseInt(variant_id) ] = qty;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then((response) => response.json())
      .then((data) => {
        if( refresh ){
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        }
      })

    //document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
};

JL.cart_features = function(){
    const updateSamples = () => {

      const updates = {};
      if( jQuery('.jl-sample.active').length > 0 ){
        updates[ parseInt( jQuery('.jl-sample.active').attr('data-id') ) ] = 1;
      }

      jQuery('.jl-sample:not(.active)').each(function(){
        updates[ parseInt( jQuery(this).attr('data-id') ) ] = 0;
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then((response) => response.json())
        .then((data) => {
          // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        })
      }
    };

    let searchParams = new URLSearchParams(window.location.search);

    if( searchParams.has('open_cart') ){
        document.querySelector('a[href="/cart"]').click();
    }

    // Extra Promotion
    function extra_promotion(){
        var variant_id = jQuery('#sidebar-cart').find('.jl-progress').attr('data-variant-id');

        if( jQuery('#sidebar-cart').find('.jl-progress').attr('data-qualifies') == '1' ){
            JL.add_to_cart( variant_id );
        }
        else{
            JL.add_to_cart( variant_id, 0 );
        }
    }

    // Free Samples - only 1 selection
    jQuery('body').on('click', '.jl-add-sample', function(e){
        e.preventDefault();

        var select_text   = jQuery(this).find('span').attr('data-text');
        var selected_text = jQuery(this).find('span').attr('data-selected-text');

        jQuery('.jl-sample').removeClass('active');
        jQuery('.jl-sample button span').text( select_text );
        jQuery(this).parent().addClass('active');
        jQuery(this).find('span').text( selected_text );

        updateSamples();
    });

    jQuery('body').on('click', '.active .jl-add-sample', function(e){
        e.preventDefault();
        jQuery(this).parent().removeClass('active');
        jQuery(this).find('span').text( jQuery(this).find('span').attr('data-text') );
        updateSamples();
    });

    jQuery('body').on('mouseenter', '.active .jl-add-sample', function(){
        jQuery(this).find('span').text('Remove');
    });

    jQuery('body').on('mouseleave', '.active .jl-add-sample', function(){
        jQuery(this).find('span').text( jQuery(this).find('span').attr('data-selected-text') );
    });

    // You May Also Like
    jQuery('body').on('click', '.jl-add-upsell', function(e){
        e.preventDefault();

        var variant_id = jQuery(this).parents('.jl-upsell-item').attr('data-id');
        JL.add_to_cart( variant_id );
    });

    var loadProductRecommendationsIntoSection = function() {
        var productRecommendationsSection = document.querySelector("#cart-recommendations");
        if (productRecommendationsSection === null) { return; }
        var productId = productRecommendationsSection.dataset.productId;


        if( productId != '' ){
            var limit = productRecommendationsSection.dataset.limit;
            var requestUrl = "/recommendations/products?section_id=cart-recommendations&limit="+limit+"&product_id="+productId;
            var request = new XMLHttpRequest();
            request.open("GET", requestUrl);
            request.onload = function() {
                if (request.status >= 200 && request.status < 300) {
                    var $response_html = jQuery( request.response ).find('#cart-recommendations');
                    jQuery('.jl-recommendations').html( $response_html );
                }
            };
            request.send();
        }
    };

    loadProductRecommendationsIntoSection();
    extra_promotion();

    setInterval(function(){

        // extra promotion check
        var variant_id = jQuery('#sidebar-cart').find('.jl-progress').attr('data-variant-id');
        if( jQuery('#sidebar-cart').find('.jl-progress').attr('data-qualifies') == '1' ){
            if( jQuery('.jl-free-gift').length == 0 ){
                JL.add_to_cart( variant_id );
            }
        }
        else{
            if( jQuery('.jl-free-gift').length ){
                jQuery('.jl-free-gift').remove();
                JL.add_to_cart( variant_id, 0, false );
            }
            else if ( jQuery('#sidebar-cart').find('.jl-progress').attr('data-qualifies') == '0' ){
                //JL.add_to_cart( variant_id, 0 );
            }
        }

        // keep free gift at the top
        if( jQuery('.jl-free-gift').length ){
            if( !jQuery('#sidebar-cart .Cart__ItemList .CartItemWrapper:first-child').find('.jl-free-gift').length ){
                jQuery('.jl-free-gift').parent().detach().prependTo('.Cart__ItemList');
            }
        }

        // recommendations
        if( jQuery('.jl-recommendations #cart-recommendations').length == 0 && jQuery('#sidebar-cart .Cart__Empty').length == 0 ){
            loadProductRecommendationsIntoSection();
        }

        // empty cart check
        if( !jQuery('.CartItem').length && !jQuery('.Cart__Empty').length ){
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        }

    }, 100);
};

JL.rechargeContentModifier = function () {
    // Check if we're on the ReCharge login page
    if (window.location.href.includes('/tools/recurring/login')) {
        // Function to check and modify content
        const checkAndModifyContent = () => {
            const errorDiv = document.querySelector('.rc_header-settings__description p');
            if (errorDiv && errorDiv.textContent.trim() === 'Sorry, there is no subscription account associated to this Shopify customer ID') {
                errorDiv.textContent = "Oops, it looks like you haven't created a subscription account. Please reach out to support@jaxonlane.com to open one.";
            }
        };

        // Initial check
        checkAndModifyContent();

        // Set up a MutationObserver to watch for dynamic content changes
        const observer = new MutationObserver(checkAndModifyContent);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};

jQuery(document).ready(function($){

    // init cart features
    JL.cart_features();

    JL.rechargeContentModifier();


    // add to cart ajax support
    $('body').on('submit', 'form.ProductForm', function (e) {
        // Only handle if the form contains the add-to-cart button
        if ($(this).find('button[data-action="add-to-cart"]').length) {
            // Safari detection
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                // Let the default form submission happen on Safari
                return;
            }
            e.preventDefault();
          debugger;

            var $form = $(this);
            var variant_id = $form.find('input[name="id"]').val();
            var quantity = $form.find('input[name="quantity"]').val() || 1;

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: $form.serialize(),
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: variant_id,
                            quantity: quantity
                        }
                    }));
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                },
                error: function (xhr) {
                    if (xhr.status === 401) {
                        alert('You must be logged in or the store must be public to add items to the cart.');
                    } else {
                        alert('An error occurred. Please try again.');
                    }
                }
            });
        }
    });

    // Past footer scripts
    $('.template-index .ArticleList, .reviews-container').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });

    $('.AnnouncementBar').slick({
        arrows: false,
        dots: false,
        infinite: false,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true
    });

    $('.points-rows').slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
});
